import { render, staticRenderFns } from "./GuiasPorCliente.vue?vue&type=template&id=90889fa0&"
import script from "./GuiasPorCliente.vue?vue&type=script&lang=js&"
export * from "./GuiasPorCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports